export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'WELCOME'        : {
                'TITLE': 'Welcome',
                'BADGE': '25'
            }
        }
    }
};
